import { useTableActions } from '../hooks/useTableActions'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Edit, TrashDelete, OverflowMenu } from '@/assets/icons'
import { IconButton } from '@/components/icon-button/IconButton'
import { MenuContent, MenuItemGroup } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'
import EditTableNameDialog from './EditTableNameDialog'
import DeleteTableItemDialog from './DeleteTableItemDialog'

export default function TableActions({
  tableId,
  name,
  disabled,
  label = 'Table actions',
  onChanged,
  onDeleted,
}: {
  tableId: string
  name: string
  disabled?: boolean
  label?: string
  onChanged: () => void
  onDeleted: () => void
}) {
  const { action, saving, error, submit, choose, close } = useTableActions(tableId, onChanged, onDeleted)
  return (
    <>
      <DropdownMenu.Root modal={false}>
        <DropdownMenu.Trigger asChild>
          <IconButton icon={<OverflowMenu />} size="sm" variant="plain" color="black" aria-label={label} disabled={disabled || saving} />
        </DropdownMenu.Trigger>
        <MenuContent align="end">
          <MenuItemGroup>
            <MenuItem label="Rename" icon={Edit} variant="neutral" onSelect={() => choose('rename')} />
            <MenuItem label="Delete" icon={TrashDelete} variant="destructive" onSelect={() => choose('delete')} />
          </MenuItemGroup>
        </MenuContent>
      </DropdownMenu.Root>
      {action === 'rename' && <EditTableNameDialog name={name} saving={saving} error={error} onSave={submit} onClose={close} />}
      {action === 'delete' && <DeleteTableItemDialog title="Delete table?" saving={saving} error={error} onCancel={close} onConfirm={() => void submit()} />}
    </>
  )
}
